import { render } from "./GiftReviewPage.vue?vue&type=template&id=6ad2a8be&scoped=true"
import script from "./GiftReviewPage.vue?vue&type=script&lang=js"
export * from "./GiftReviewPage.vue?vue&type=script&lang=js"

import "./GiftReviewPage.vue?vue&type=style&index=0&id=6ad2a8be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad2a8be"]])

export default __exports__